var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavBarTogglerIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87488 3.63906C9.74596 3.51017 9.57112 3.43777 9.38882 3.43777C9.20652 3.43777 9.03168 3.51017 8.90276 3.63906L5.49963 7.04218L2.09651 3.63906C1.96684 3.51382 1.79318 3.44453 1.61292 3.44609C1.43266 3.44766 1.26022 3.51996 1.13275 3.64743C1.00529 3.7749 0.932984 3.94733 0.931418 4.12759C0.929851 4.30785 0.999147 4.48152 1.12438 4.61118L5.01357 8.50037C5.14249 8.62926 5.31733 8.70166 5.49963 8.70166C5.68193 8.70166 5.85677 8.62926 5.98569 8.50037L9.87488 4.61118C10.0038 4.48226 10.0762 4.30742 10.0762 4.12512C10.0762 3.94282 10.0038 3.76798 9.87488 3.63906Z",
    fill: "#070707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarTogglerIconNew);
export default __webpack_public_path__ + "static/media/NavBarTogglerIconNew.f0a11168cc457f702f5fd41b1aa026de.svg";
export { ForwardRef as ReactComponent };